import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CanadaPostService } from 'app/modules/survey/survey-viewer/services/canada-post.service'
import { ICountry } from 'app/interfaces/ICountry'

@Component({
    selector: 'app-countries',
    templateUrl: './countries.component.html',
    styleUrls: ['./countries.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CountriesComponent implements OnInit {

  @Input() activeLang: string
  @Output() countryChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectedCountryName: string
  filteredCountries: ICountry[]

  constructor(private canadaPostService: CanadaPostService) { }

  ngOnInit(): void {
    this.selectedCountryName = this.canadaPostService.selectedCountry$.value.name
    this.filteredCountries = this.canadaPostService.countries
  }

  filterCountries(event): void {
    this.filteredCountries = this.canadaPostService.countries.filter(c => c.name.toLowerCase().includes(event.target.value.toLowerCase()))
  }

  changeCountry(event): void {
    this.canadaPostService.findAddresses('', '')
    this.canadaPostService.selectedCountry$.next(event.option.value)
    this.countryChanged.emit(true)
  }

  displayFn = (event): string => {
    return event.name
  }
}
